import React, { useMemo, useState } from "react";
import { useAsyncDebounce } from "react-table";
import { Label, Input } from "reactstrap";

// Global filter component
export function GlobalFilter({ globalFilter, setGlobalFilter }) {
  const [value, setValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((val) => {
    setGlobalFilter(val || undefined);
  }, 200);

  return (
    <div style={{ margin: "10px 0" }}>
      <Label>Search Table:</Label>{" "}
      <Input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder="Enter value"
        style={{ display: "inline", width: "auto" }}
      />
    </div>
  );
}

// Default column filter (text input)
export function DefaultFilterForColumn({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;
  return (
    <Input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder={`Search ${count} records...`}
      style={{ marginTop: "5px", width: "100%" }}
    />
  );
}

// Select filter for columns with limited options
export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  const options = useMemo(() => {
    const opts = new Set();
    preFilteredRows.forEach((row) => {
      opts.add(row.values[id]);
    });
    return [...opts.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      value={filterValue}
      onChange={(e) => setFilter(e.target.value || undefined)}
      style={{ width: "100%", marginTop: "5px" }}
    >
      <option value="">All</option>
      {options.map((option, idx) => (
        <option key={idx} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}

// Date range filter function
export function dateBetweenFilterFn(rows, id, filterValues) {
  let [start, end] = filterValues || [];
  if (!start && !end) return rows;

  start = start ? new Date(start) : null;
  end = end ? new Date(end) : null;

  return rows.filter((row) => {
    const rowDate = new Date(row.values[id]);
    if (start && rowDate < start) return false;
    if (end && rowDate > end) return false;
    return true;
  });
}

dateBetweenFilterFn.autoRemove = (val) => !val;

// Date range picker filter component
export function DateRangeColumnFilter({
  column: { filterValue = [], setFilter },
}) {
  return (
    <div style={{ display: "flex", gap: "4px", marginTop: "5px" }}>
      <Input
        type="date"
        value={filterValue[0] || ""}
        onChange={(e) => {
          const val = e.target.value;
          setFilter((old = []) => [val || undefined, old[1]]);
        }}
        style={{ width: "100%" }}
      />
      <Input
        type="date"
        value={filterValue[1] || ""}
        onChange={(e) => {
          const val = e.target.value;
          setFilter((old = []) => [old[0], val || undefined]);
        }}
        style={{ width: "100%" }}
      />
    </div>
  );
}
